import type { AllRouteEndpoints } from "../routeTypes";

export const appGroupIdOperatorMcpConnectionsConnectionId =
  "/:app_group_id/operator_mcp_connections/:connection_id";

export const deleteAppGroupIdOperatorMcpConnectionsConnectionIdCacheKeys: AllRouteEndpoints[] = [
  "/:app_group_id/operator_mcp_connections",
  "/:app_group_id/operator_mcp_connections/tools",
];
